import React, { useState, useEffect } from 'react';
import history from '../../history';
import useActiveHeirarchy from '../../utils/useActiveHeirarchy';
import Header from '../../components/Header';
import HeaderAndFooter from '../../components/HeaderAndFooter';
import List from '../../components/List';
import { fetchSafetyMeetings } from '../../api/v4';

export default function SafetyMeetingList() {
  const { location, project } = useActiveHeirarchy();
  const [list, setList] = useState([]);
  useEffect(() => {
    fetchSafetyMeetings().then(setList);
  }, []);

  const header = (
    <Header
      title="Safety Meetings"
      pageActionOptions={[
        {
          label: 'Create Safety Meeting',
          color: 'blueOutline',
          onClick: () => history.push(`/app/safetyMeeting/container`),
          visible: true
        }
      ]}
    />
  );
  const columns = [
    {
      label: 'Meeting Title',
      key: 'title'
    },
    {
      label: 'Date Occurred',
      key: 'dateOccurred',
      datatype: 'date'
    },
    {
      label: 'Admin',
      key: 'admin',
      datatype: 'user'
    },
    {
      label: 'Attendees',
      key: 'attendees',
      datatype: 'users'
    }
  ];
  if (!project && location) {
    columns.splice(1, 0, {
      key: 'projectId',
      label: 'Area',
      datatype: 'project'
    });
  }
  if (!location) {
    columns.splice(1, 0, {
      key: 'groupId',
      label: 'Group/Est.',
      datatype: 'group'
    });
  }

  return (
    <HeaderAndFooter Header={header}>
      <List
        settings={columns}
        data={list}
        dataIsHash
        saveKey="safetyMeetings"
        rowClick={row =>
          history.push(`/app/safetyMeeting/container/${row._id}`)
        }
        getRowId={row => row._id}
      />
    </HeaderAndFooter>
  );
}
